import { Scale, FileSearch, ShieldCheck, Wrench, Layers, FileDiff } from "lucide-react";

export const MODES = [
  { key: "contract_risk", label: "Contract Risk", icon: Scale, desc: "Legal & commercial risk — indemnity, LDs, retainage, flow-downs." },
  { key: "steel_spec", label: "Steel Specification", icon: FileSearch, desc: "Div 05 & 10 deep dive — materials, coatings, AESS, welding, bolting." },
  { key: "aisc_compliance", label: "AISC / AWS Compliance", icon: ShieldCheck, desc: "AISC 303/360/341 & AWS D1.1 — deviations, custom requirements." },
  { key: "spec_vs_drawings", label: "Spec vs. Drawings", icon: Layers, desc: "Cross-check structural drawing notes & schedules against Div 05 spec — grades, bolts, welds, connection design.", needsDrawing: true },
  { key: "addendum_review", label: "Addendum / Change Review", icon: FileDiff, desc: "Ongoing project: compare addenda, bulletins & change docs against the base documents and prior findings — flags cost, schedule and scope impacts.", needsAddendum: true },
  { key: "custom", label: "Custom Instructions", icon: Wrench, desc: "Your review lens combined with active playbook rules." },
];

const HINT = { addendum: "Select only the addendum/bulletin document(s) — the base documents and prior findings are pulled in automatically.", drawing: "Select a Structural Drawings document plus the spec for a cross-check." };

export function ModePicker({ mode, setMode, docs, selectedDocs }) {
  const has = (type) => docs.some((d) => d.doc_type === type && selectedDocs.includes(d.id));
  return (
    <div className="grid grid-cols-2 gap-2">
      {MODES.map((m) => {
        const Icon = m.icon;
        const active = mode === m.key;
        const warn = (m.needsDrawing && !has("drawing")) || (m.needsAddendum && !has("addendum"));
        return (
          <button key={m.key} onClick={() => setMode(m.key)} className={`text-left p-3 rounded-md border transition ${active ? "border-amber-500/60 bg-amber-500/5" : "border-slate-800 hover:border-slate-700"}`} data-testid={`ai-review-mode-${m.key.replace(/_/g, "-")}`}>
            <Icon className={`w-4 h-4 mb-1.5 ${active ? "text-amber-400" : "text-slate-400"}`} />
            <div className={`text-sm font-semibold ${active ? "text-slate-100" : "text-slate-300"}`}>{m.label}</div>
            <div className="text-xs text-slate-500 mt-1 leading-snug">{m.desc}</div>
            {warn && active && <div className="text-[11px] text-amber-400 mt-1" data-testid="mode-needs-drawing-hint">{m.needsAddendum ? HINT.addendum : HINT.drawing}</div>}
          </button>
        );
      })}
    </div>
  );
}
